import { PayloadAction } from '@reduxjs/toolkit'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { addToasterMessage } from 'shared/store/toaster'
import {
  fetchCommentsError,
  fetchCommentsRequest,
  fetchCommentsSuccess,
  createCommentsRequest,
  deleteCommentsRequest,
  deleteCommentsError,
  deleteCommentsSuccess,
  createCommentsSuccess,
  createCommentsError,
  editCommentsSuccess,
  editCommentsError,
  editCommentsRequest,
  fetchCommentsSilentRequest,
  fetchCommentsSilentError,
  fetchCommentsSilentSuccess,
} from '.'
import {
  createBoardComment,
  deleteBoardComment,
  editBoardComment,
  getCaseComments,
  getMeetingComments,
} from '../../api/boardComments.api'
import {
  IBoardActivityFetchModel,
  BoardActivityStatusEnum,
  IBoardActivityUpdateModel,
} from '../../models/Comments'

function* fetchComments({ payload }: PayloadAction<IBoardActivityFetchModel>) {
  try {
    const { data } = yield call(
      payload.type === BoardActivityStatusEnum.Case
        ? getCaseComments
        : getMeetingComments,
      payload.id
    )

    yield put(fetchCommentsSuccess(data))
  } catch (e) {
    console.log(e)
    yield put(fetchCommentsError(e))
  }
}

function* fetchCommentsSilent({
  payload,
}: PayloadAction<IBoardActivityUpdateModel>) {
  try {
    const { data } = yield call(
      payload.type === BoardActivityStatusEnum.Case
        ? getCaseComments
        : getMeetingComments,
      payload.id
    )
    yield put(fetchCommentsSilentSuccess(data))
  } catch (e) {
    yield put(fetchCommentsSilentError(e))
  }
}
function* addComment({ payload }: PayloadAction<IBoardActivityUpdateModel>) {
  try {
    yield call(createBoardComment, payload, {
      text: payload.text!,
    })
    yield all([
      put(createCommentsSuccess()),
      put(fetchCommentsSilentRequest(payload)),
    ])
  } catch (e) {
    yield put(createCommentsError(e))
  }
}

function* editComment({ payload }: PayloadAction<IBoardActivityUpdateModel>) {
  try {
    yield call(editBoardComment, payload, {
      text: payload.text!,
    })
    yield all([
      put(editCommentsSuccess()),
      put(fetchCommentsSilentRequest(payload)),
    ])
  } catch (e) {
    yield put(
      addToasterMessage({
        text: 'Klarte ikke lagre kommentar',
        type: 'danger',
      })
    )
    yield put(editCommentsError(e))
  }
}

function* deleteComment({ payload }: PayloadAction<IBoardActivityUpdateModel>) {
  try {
    yield call(deleteBoardComment, payload)
    yield all([
      put(deleteCommentsSuccess()),
      put(fetchCommentsSilentRequest(payload)),
    ])
  } catch (e) {
    yield put(
      addToasterMessage({
        text: 'Klarte ikke slette kommentar',
        type: 'danger',
      })
    )
    yield put(deleteCommentsError(e))
  }
}

function* commentsSaga() {
  yield takeEvery(fetchCommentsRequest, fetchComments)
  yield takeEvery(fetchCommentsSilentRequest, fetchCommentsSilent)
  yield takeEvery(createCommentsRequest, addComment)
  yield takeEvery(editCommentsRequest, editComment)
  yield takeEvery(deleteCommentsRequest, deleteComment)
}

export default commentsSaga
